<div class="p-3">

    <!-- <div class="d-flex justify-content-between my-4 mx-3">
        <div class="row">
        <h5>Approved Preliminary Design -  <span class="text-primary"> [{{payload?.proposal_name}}]</span></h5>
         <h6><span class="text-primary"> [
                    {{
                    stepDetails?.step_status == 0
                    ? 'INITIATION PENDING'
                    : (stepDetails?.step_status | uppercase)
                    }}
                    ]</span></h6>
                </div>
        <div class="d-flex gap-2">
            <p-button pTooltip="Generate PDF" icon="pi pi-file-pdf" (onClick)="generatePDF()"
                [outlined]="true"></p-button>
            
              <p-button label="Next" icon="pi pi-angle-right" iconPos="right" (onClick)="goToNextStep()"
                [outlined]="true" *ngIf="stepDetails?.step_status == 'approved'"></p-button>
            <p-button label="Submit" icon="pi pi-save" (onClick)="onSubmit()" [outlined]="true" *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender|| (stepDetails?.step_status != 'approved' && userID == 6)"></p-button>
            <p-button label="Initiate" icon="pi pi-play" *ngIf="stepDetails?.is_initiator"
                (onClick)="IRA.emit('Initiate')" [outlined]="true"></p-button>
            <p-button label="Approve" icon="pi pi-check-circle" *ngIf="stepDetails?.is_approver"
                (onClick)="IRA.emit('Approve')" [outlined]="true"></p-button>
            <p-button label="Recommend" icon="pi pi-thumbs-up" *ngIf="stepDetails?.is_recommender"
                (onClick)="IRA.emit('Recommend')" [outlined]="true"></p-button>


        </div>
    </div>
    <hr> -->
     <div class="page-header mb-4">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h4 class="mb-1">
                    {{ schemeType === 'tdf' ? 'Approval' : 'Approved Preliminary Design' }}
                </h4>
                <h5 class="text-primary">[{{payload?.proposal_name}}]</h5>
                <div class="status-badge">
                    <span class="badge" [ngClass]="{
                        'bg-secondary': stepDetails?.step_status == 0,
                        'bg-success': stepDetails?.step_status == 'approved',
                        'bg-warning': stepDetails?.step_status == 'recommended',
                        'bg-info': stepDetails?.step_status == 'initiated'
                    }">
                        {{
                        stepDetails?.step_status == 0
                        ? 'INITIATION PENDING'
                        : (stepDetails?.step_status | uppercase)
                        }}
                    </span>
                </div>
            </div>

            <!-- <div class="action-buttons" *ngIf="status === 'received'"> -->
            <div class="action-buttons">
                <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
                    <i class="pi pi-file-pdf me-1"></i> PDF
                </button>

                <ng-container *ngIf="stepDetails?.step_status == 'approved'">
                    <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
                        Next <i class="pi pi-angle-right ms-1"></i>
                    </button>
                </ng-container>

                <ng-container
                    *ngIf="stepDetails?.can_edit || (stepDetails?.step_status != 'approved' && userID == 6)">
                    <button class="btn btn-primary me-2" (click)="routeConfig.emit({isRouteConfig: true})"  [disabled]="(schemeType === 'TDF' && proposalForm?.invalid) || 
                (schemeType !== 'TDF' && challengeForm?.invalid)">
                        <i class="pi pi-save me-1"></i> Save/Forward/Route Config
                    </button>
                </ng-container>

                <ng-container *ngIf="stepDetails?.is_initiator">
                    <button class="btn btn-success" (click)="IRA.emit('Initiate')">
                        <i class="pi pi-play me-1"></i> Initiate
                    </button>
                </ng-container>

                <ng-container *ngIf="stepDetails?.is_approver">
                    <button class="btn btn-success" (click)="IRA.emit('Approve')">
                        <i class="pi pi-check-circle me-1"></i> Approve
                    </button>
                </ng-container>

                <ng-container *ngIf="stepDetails?.is_recommender">
                    <button class="btn btn-info" (click)="IRA.emit('Recommend')">
                        <i class="pi pi-thumbs-up me-1"></i> Recommend
                    </button>
                </ng-container>
            </div>
        </div>
    </div>

    <hr class="my-3">


   
    <div class="row mb-4">
      <app-upload-document [title]="'Preliminary Design Document'" [isEditable]="stepDetails?.can_edit"></app-upload-document>
        
      </div>


    <form [formGroup]="commentForm">
        <div class="editor-field" [class.readonly-editor]="isEditorDisabled">
            <div class="bg-primary text-white fw-semibold p-2">Comment <span class="text-warning">*</span></div>
            <editor [init]="init" formControlName="comment" [disabled]="isEditorDisabled"></editor>
        </div>
    </form>
</div>